import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'

interface Achievement {
  id: string;
  user_id: string;
  type: 'training_goal' | 'belt_promotion' | 'stripe_promotion' | 'training_milestone' | 'ranked_up';
  title: string;
  description: string;
  metadata: {
    month?: string;
    trainings_count?: number;
    belt_color?: string;
    school?: string;
    ordinal_stripe?: string;
    technique_category?: string;
    milestone?: number;
    total_completed?: number;
    training_id?: string;
  };
  created_at: string;
}

export const useUserAchievements = (userId: string) => {
  return useQuery({
    queryKey: ['user-achievements', userId],
    queryFn: async (): Promise<Achievement[]> => {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) {
        throw new Error('User not authenticated')
      }

      const { data, error } = await supabase.functions.invoke('get_user_achievements', {
        body: { target_user_id: userId }
      })

      if (error) {
        throw new Error(error.message)
      }

      return data.achievements || []
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
} 